import Player from '../plugins/VimeoPluginApi.js';
import '../plugins/YoutubePluginApi.js';

export default function initVideoExpandableBlock() {
	var $offsetBlock = jQuery('#header');
	var playingClass = 'vimeo-playing';
	var pausedClass = 'vimeo-paused';
	var loadingClass = 'vimeo-loading';

	function youtube_parser(url) {
		var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
		var match = url.match(regExp);
		return (match && match[7].length == 11) ? match[7] : false;
	}

	function initYTPlayer() {
		jQuery('[data-youtube-url]').each(function() {
			var $video = jQuery(this);
			var $iframePlaceholder = jQuery('<div>');
			var timer = null;

			$iframePlaceholder.appendTo($video);

			var player = new YT.Player($iframePlaceholder[0], {
				height: $video.data('height') || 1080,
				width: $video.data('width') || 1920,
				videoId: youtube_parser($video.data('youtubeUrl')),
				events: {
					'onReady': function(e) {
						$video.data('player', player);
					},
					'onStateChange': function(e) {
						clearTimeout(timer);
						timer = setTimeout(function() {
							if (e.data === 1) {
								$video.trigger('videoPlay');
							} else if (e.data === 2) {
								$video.trigger('videoPause');
							} else if (e.data === 0) {
								$video.trigger('videoPause');
							}
						}, 200);
					}
				}
			});

		});
	}

	if (window.YouTubeAPIReady) {
		initYTPlayer();
	} else {
		jQuery(window).on('YouTubeAPIReady', initYTPlayer);
	}

	jQuery('[data-vimeo-url]').each(function() {
		var $video = jQuery(this);
		var player = new Player(this);

		jQuery(this).data('player', player);

		player.on('play', function() {
			$video.trigger('videoPlay');
		});

		player.on('pause', function() {
			$video.trigger('videoPause');
		});

		player.on('ended', function() {
			$video.trigger('videoPause');
		});
	});


	jQuery('.js-video-group').each(function() {
		var $holder = jQuery(this);
		var $bgvideoHolder = $holder.find('.js-video-stretch');
		var $videoPlaceholder = $holder.find('.js-video-placeholder');
		var $video = $holder.find('[data-vimeo-url], [data-youtube-url]');
		var $btnPlay = $holder.find('.js-play-vimeo');
		var $btnPause = $holder.find('.js-pause-vimeo');
		var $btnClose = $holder.find('.js-close-vimeo');
		var $gallery = $holder.closest('.main-gallery');

		$holder.addClass(pausedClass);

		$video.on('videoPlay', function() {
			$holder.removeClass(loadingClass).removeClass(pausedClass).addClass(playingClass);

			recalcHeight();
			repositionHolder();

			$gallery.trigger('onPlayFullvideo', $video);
		});

		$video.on('videoPause', function() {
			$holder.removeClass(loadingClass).removeClass(playingClass).addClass(pausedClass);

			recalcHeight();
			resetPositionHolder();

			$gallery.trigger('onPauseFullvideo', $video);
		});

		$btnPlay.on('click', function(e) {
			e.preventDefault();

			const cookiesRequired = !!$video.data('cookiesRequired');
			const cookiesAccepted = !!(window.ccc && window.ccc.functional);
			const canLoadVideo = !cookiesRequired || (cookiesRequired && cookiesAccepted);
			if (!canLoadVideo) {
				return;
			}

			if (!$holder.hasClass(playingClass)) {
				$holder.addClass(loadingClass);

				$gallery.trigger('onLoadFullvideo', $video);

				if ($video.data('player')) {
					if ($video.data('vimeoUrl')) {
						$video.data('player').pause();
						$video.data('player').play();
					}
						
					if ($video.data('youtubeUrl')) {
						$video.data('player').pauseVideo();
						$video.data('player').playVideo();
					}
				}
			}

			recalcHeight();
		});

		$btnPause.on('click', function(e) {
			e.preventDefault();

			if ($holder.hasClass(playingClass)) {
				$holder.removeClass(playingClass);

				if ($video.data('vimeoUrl')) {
					$video.data('player').pause();
				}
					
				if ($video.data('youtubeUrl')) {
					$video.data('player').pauseVideo();
				}
			}

			recalcHeight();
		});

		$btnClose.on('click', function(e) {
			e.preventDefault();

			if ($holder.hasClass(playingClass)) {
				$holder.removeClass(playingClass);

				if ($video.data('vimeoUrl')) {
					$video.data('player').pause();
				}
					
				if ($video.data('youtubeUrl')) {
					$video.data('player').pauseVideo();
				}
			}

			recalcHeight();
		});

		function recalcHeight() {
			if ($holder.hasClass(playingClass)) {
				$holder.css('height', $videoPlaceholder.outerHeight());
			} else {
				$holder.height('');
			}
		}

		function repositionHolder() {
			if ($offsetBlock.length) {
				$holder.css('transform', 'translateY(-' + $offsetBlock.outerHeight() + 'px)');
			}
		}

		function resetPositionHolder() {
			if ($offsetBlock.length) {
				$holder.css('transform', 'translateY(0px)');
			}
		}

		recalcHeight();

		jQuery(window).on('resize orientationchange', recalcHeight);
	});
}
